import GLightbox from "glightbox";
import "glightbox/dist/css/glightbox.css";

GLightbox();
